<div class="import-view">
    <ng-container [dynamic]="view()"></ng-container>
</div>
